import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "m-4 flex flex-col gap-3" }
const _hoisted_2 = { class: "flex justify-center items-center gap-1" }

import { computed, ref, watch } from "vue";
import { Keys } from "@/keyboard";
import { fromSelectedKeys, toSelectedKeys } from "@/keyboard/keys_utils";
import { useKeyboardStore, useLayoutStore } from "@/stores";
import PopupButton from "@/components/utils/PopupButton.vue";
import KeysSelect from "@/components/leds/KeysSelect.vue";

type Key = ReturnType<typeof layout.layout.iter>[0];

export default /*@__PURE__*/_defineComponent({
  __name: 'KeysEdit',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const kb = useKeyboardStore();
const layout = useLayoutStore();

const keys = computed(() =>
  props.modelValue == undefined ? null : props.modelValue
);
const selectedKeys = ref(toSelectedKeys(keys.value));
watch(keys, (newKeys) => (selectedKeys.value = toSelectedKeys(newKeys)));

const toggleKey = (row: number, col: number) => {
  selectedKeys.value.has(row, col)
    ? selectedKeys.value.remove(row, col)
    : selectedKeys.value.add(row, col);
  if (selectedKeys.value.count > 0)
    emit("update:modelValue", fromSelectedKeys(selectedKeys.value));
};

const setAll = (selected: (key: Key) => boolean) => {
  layout.layout
    .iter()
    .forEach((key) =>
      selected(key)
        ? selectedKeys.value.add(key.row, key.col)
        : selectedKeys.value.remove(key.row, key.col)
    );
  if (selectedKeys.value.count > 0)
    emit("update:modelValue", fromSelectedKeys(selectedKeys.value));
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PopupButton, {
    placement: 'auto',
    offset: 6,
    renderOnShow: true
  }, {
    button: _withCtx(() => _cache[4] || (_cache[4] = [
      _createElementVNode("div", { class: "btn btn-neutral btn-sm" }, "Select", -1)
    ])),
    popup: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[5] || (_cache[5] = _createElementVNode("span", { class: "text-center text-sm" }, " Click on keys or hold left mouse button and hover over them. ", -1)),
        _createVNode(KeysSelect, {
          width: 600,
          height: 2000,
          isSelected: (r, c) => selectedKeys.value.has(r, c),
          onKeyClicked: toggleKey
        }, null, 8, ["isSelected"]),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("button", {
            class: "btn btn-neutral btn-sm",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (setAll(() => true)))
          }, " All "),
          _createElementVNode("button", {
            class: "btn btn-neutral btn-sm",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (setAll(() => false)))
          }, " Clear "),
          _createElementVNode("button", {
            class: "btn btn-neutral btn-sm",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (setAll((k) => k.col < _unref(kb).columns / 2)))
          }, " Left "),
          _createElementVNode("button", {
            class: "btn btn-neutral btn-sm",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (setAll((k) => k.col >= _unref(kb).columns / 2)))
          }, " Right ")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})